    const marketingCategory = 'C0004';
    const analyticsCategory = 'C0002';
    const functionalCategory = 'C0003';

    function waitForOneTrust() {
        hasOneTrustLoaded();

        let attempts = 0;
        const interval = setInterval(function () {

            if (hasOneTrustLoaded() || attempts > 100){
                clearInterval(interval);
            } 

            attempts++;

        }, 100)

    }

    function hasOneTrustLoaded() {
        
        if(typeof window.OnetrustActiveGroups === 'string'){
            //check now
            optanonWrapper()
            // and wrap and trigger after cookie opt-in
            window.OptanonWrapper = optanonWrapper;
            return true;

        }
        
        return false;
        
    }

    function sendConsent(trackingConsent) {
        window.Shopify.customerPrivacy.setTrackingConsent(trackingConsent);
    }

    function optanonWrapper() {

        const trackingConsentAnalytics = !!window.OnetrustActiveGroups.includes(analyticsCategory);
        const trackingConsentMarketing = !!window.OnetrustActiveGroups.includes(marketingCategory);
        const trackingConsentFunctional = !!window.OnetrustActiveGroups.includes(functionalCategory);
        const trackingConsent =   {
            "analytics":    trackingConsentAnalytics,
            "marketing":    trackingConsentMarketing,
            "preferences":  trackingConsentFunctional
          };
        window.Shopify.loadFeatures(
            [
                {
                    name: 'consent-tracking-api',
                    version: '0.1',
                },
            ],
            error => {
                if (error) {
                    throw error; 
                }

                sendConsent(trackingConsent)

            },
        );   
    }

    (function () {
        waitForOneTrust();
    })();

